import { parseWasmResult } from '#wasm/common';
export class TupleWasm {
    mod;
    constructor(mod) {
        this.mod = mod;
    }
    makeTupleFromString(argument) {
        return parseWasmResult(this.mod.MakeTupleFromString(argument));
    }
    makeTupleFromBytesArray(array) {
        return parseWasmResult(this.mod.MakeTupleFromBytesArray(array));
    }
    makeTupleFromStringArray(array) {
        return parseWasmResult(this.mod.MakeTupleFromStringArray(array));
    }
    makeTupleFromUint32(num) {
        return parseWasmResult(this.mod.MakeTupleFromUint32(num));
    }
    makeTupleFromUint64(num) {
        return parseWasmResult(this.mod.MakeTupleFromUint64(num.toString()));
    }
    makeTupleFromStringUint32(str, num) {
        return parseWasmResult(this.mod.MakeTupleFromStringUint32(str, num));
    }
    getStringFromTuple(value, index = 0) {
        return parseWasmResult(this.mod.GetStringFromTuple(value, index));
    }
    getUint32FromTuple(value, index = 0) {
        return parseWasmResult(this.mod.GetUint32FromTuple(value, index));
    }
    getUint64FromTuple(value, index = 0) {
        return parseWasmResult(this.mod.GetUint64FromTuple(value, index));
    }
    getTupleFromTuple(value, index = 0) {
        return parseWasmResult(this.mod.GetTupleFromTuple(value, index));
    }
    getByteArrayFromStringTuple(value, index = 0) {
        return parseWasmResult(this.mod.GetByteArrayFromStringTuple(value, index));
    }
    getMultiStringFromTuple(value) {
        return parseWasmResult(this.mod.GetMultiStringFromTuple(value));
    }
}
